function formatMoney(amount, currency, format, formatToTwoDecimalPlaces = false) {
  const amt = Number(amount);
  const options = {
    style: 'currency',
    currency: currency || 'GBP',
    minimumFractionDigits: 2
  };
  const intl = format || 'en-GB';
  // if its a whole, dollar amount, leave off the .00
  if (!formatToTwoDecimalPlaces && (Math.ceil(amt) === Math.floor(amt))) options.minimumFractionDigits = 0;
  const formatter = new Intl.NumberFormat(intl, options);
  return formatter.format(amt);
}

export { formatMoney };
